var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtablissement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#EE7203;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.9,46.2L63,11.2c-0.6-0.5-1.4-0.5-1.9,0L21,46.1c-0.6,0.5-0.7,1.5-0.1,2.1c0.5,0.6,1.5,0.7,2.1,0.1 l8.6-7.5v46.9c0,0.8,0.7,1.5,1.5,1.5h57.4c0.8,0,1.5-0.7,1.5-1.5V39.8l10.1,8.7c0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5 C104.6,47.7,104.6,46.7,103.9,46.2z M89,86.2H34.5V38.2l27.5-24l26.9,23L89,86.2L89,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.3,41.3v14.6H45.7c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5h14.6v14.6c0,0.8,0.7,1.5,1.5,1.5 s1.5-0.7,1.5-1.5V58.8h14.6c0.8,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5H63.2V41.3c0-0.8-0.7-1.5-1.5-1.5S60.3,40.5,60.3,41.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtablissement);
export default __webpack_public_path__ + "static/media/etablissement.31c679276592fb6d6796aaf08af394a0.svg";
export { ForwardRef as ReactComponent };